import Vuex from "vuex";
import search from "./store_modules/search";
import main from "./store_modules/main";

const store = new Vuex.Store({
  modules: {
    search,
    main,
  },
  state: {
    refs: {},
    listeners: {
      popstate: {
        main: false,
        search: false,
      },
    },
    location: null,
  },
  getters: {
    getPopstsateListener: (state) => (name) => {
      return state.listeners.popstate[name];
    },
    getLocale: () => {
      let locale = "",
        doc_lang = document.documentElement.lang;

      if (doc_lang !== "nl") locale = "/" + doc_lang;

      return locale;
    },
    parseParams: () => {
      // parse query string
      const params = new URLSearchParams(window.location.search);

      const obj = {};

      // iterate over all keys
      for (const key of params.keys()) {
        if (params.getAll(key).length > 1) {
          obj[key] = params.getAll(key);
        } else {
          obj[key] = params.get(key);
        }
      }

      return obj;
    },
    getCategory: (state) => (id) => {
      return CATEGORY_LIST.find((i) => {
        return i.id === parseInt(id);
      });
    },
    getRef: (state) => (name) => {
      return state.refs[name];
    },
    getLocation(state) {
      return state.location;
    },
  },
  mutations: {
    setPopstsateListener: (state, payload) => {
      state.listeners.popstate[payload.name] = payload.value;
    },
    setRef(state, v) {
      state.refs[v.name] = v.value;
    },
    setLocation(state, v) {
      state.location = v;
    },
  },
  actions: {
    setRefs({ commit }, _this) {
      for (var i in _this.$parent.$refs)
        commit("setRef", {
          name: i,
          value: _this.$parent.$refs[i],
        });

      for (var IN in _this.$refs)
        commit("setRef", {
          name: IN,
          value: _this.$refs[IN],
        });
    },
  },
});

export default store;
